module.exports = __webpack_public_path__ + "static/media/arbi.ad1b6d3b.jpg";